import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Etiketleme, KanunMaddeleri } from './Etiketleme.js';
import { KategoriSecici, Kategori } from '../Kategorilendirme';
import { toast } from 'react-toastify';

const DetaylarModal = ({
  duzenlenmisSablon,
  kategoriler = [],
  onClose,
  kayitliEtiketler,
  kayitliKanunMaddeleri,
  onSave
}) => {
  const [localSablon, setLocalSablon] = useState(duzenlenmisSablon);

  useEffect(() => {
    setLocalSablon({
      ...duzenlenmisSablon,
      kategoriler: duzenlenmisSablon.kategoriler
        ? duzenlenmisSablon.kategoriler
            .filter(kategori => kategori && typeof kategori.id === 'number' && kategori.isim)
            .map(kategori => new Kategori(kategori.id, kategori.isim))
        : []
    });
  }, [duzenlenmisSablon]);

  const handleEtiketChange = (yeniEtiketler) => {
    setLocalSablon(prev => ({ ...prev, etiketler: yeniEtiketler }));
  };

  const handleKanunMaddeleriChange = (yeniKanunMaddeleri) => {
    setLocalSablon(prev => ({ ...prev, kanun_maddeleri: yeniKanunMaddeleri }));
  };

  const handleLocalChange = (e) => {
    const { name, value } = e.target;
    setLocalSablon(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const updatedSablon = {
      ...localSablon,
      etiketler: localSablon.etiketler.map(etiket => typeof etiket === 'object' ? etiket.value : etiket),
      kanun_maddeleri: localSablon.kanun_maddeleri.map(madde => typeof madde === 'object' ? madde.value : madde),
      kategoriler: localSablon.kategoriler
        .filter(kategori => kategori instanceof Kategori && typeof kategori.id === 'number' && kategori.isim)
        .map(kategori => ({
          id: kategori.id,
          isim: kategori.isim
        }))
    };

    try {
      await onSave(updatedSablon);
      toast.success('Şablon başarıyla kaydedildi.');
      onClose();
    } catch (error) {
      console.error('Şablon kaydedilirken hata:', error);
      toast.error('Şablon kaydedilirken bir hata oluştu.');
    }
  };

  const etiketler = localSablon?.etiketler || [];
  const kanunMaddeleri = localSablon?.kanun_maddeleri || [];
  const kayitliEtiketlerArray = kayitliEtiketler || [];
  const kayitliKanunMaddeleriArray = kayitliKanunMaddeleri || [];

  return (
    <div className="app-modal-overlay">
      <div className="relative w-full max-w-lg rounded-2xl border border-slate-200 bg-white shadow-2xl animate-fade-in-up">
        <div className="app-modal-header">
          <h2 className="app-modal-title">Detayları Düzenle</h2>
          <button onClick={onClose} className="app-modal-close" aria-label="Kapat">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="app-modal-body space-y-5">
          <div>
            <label htmlFor="ozet" className="app-label">Özet</label>
            <textarea
              id="ozet"
              name="ozet"
              value={localSablon?.ozet || ''}
              onChange={handleLocalChange}
              className="app-input"
              rows="4"
            />
          </div>
          <div>
            <label htmlFor="baslik" className="app-label">Başlık</label>
            <input
              type="text"
              id="baslik"
              name="baslik"
              value={localSablon?.baslik || ''}
              onChange={handleLocalChange}
              className="app-input"
            />
          </div>
          <div>
            <Etiketleme
              etiketler={etiketler}
              onChange={handleEtiketChange}
              kayitliEtiketler={kayitliEtiketlerArray.map(etiket => typeof etiket === 'string' ? etiket : etiket.value)}
            />
          </div>
          <div>
            <KanunMaddeleri
              kanunMaddeleri={kanunMaddeleri}
              onChange={handleKanunMaddeleriChange}
              kayitliKanunMaddeleri={kayitliKanunMaddeleriArray.map(madde => typeof madde === 'string' ? madde : madde.value)}
            />
          </div>
          <div>
            <label className="app-label">Kategoriler</label>
            <KategoriSecici
              kategoriler={kategoriler}
              secilenKategoriler={localSablon.kategoriler}
              onChange={(updatedKategoriler) => {
                setLocalSablon(prev => ({
                  ...prev,
                  kategoriler: updatedKategoriler.filter(k => k instanceof Kategori && k.id && k.isim)
                }));
              }}
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t border-slate-100 px-5 py-4">
          <button onClick={onClose} className="btn-secondary">
            İptal
          </button>
          <button onClick={handleSave} className="btn-primary">
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetaylarModal;
